import React from 'react';
import {checkCircle} from '@sail/icons/react/Icon';
import {TerminalScreen} from 'src/v2/components/screen/TerminalScreen';
import {useSessionContext} from 'src/state/usePayinSessionContext';

import {message, useIntl} from '@sail/intl';

const messages = {
  paymentTitle: message({
    id: 'crypto.payins.v2.success_screen.payment_title',
    description: 'Title for screen after successful payment',
    defaultMessage: 'Thanks for your payment',
  }),

  setupTitle: message({
    id: 'crypto.payins.v2.success_screen.setup_title',
    description: 'Title for screen after successful setup',
    defaultMessage: 'Your payment details are saved',
  }),
};

export const SuccessScreen = () => {
  const intl = useIntl();
  const {mode} = useSessionContext();

  const titleMessage =
    mode === 'pay' ? messages.paymentTitle : messages.setupTitle;

  return (
    <TerminalScreen
      title={intl.formatMessage(titleMessage)}
      icon={checkCircle}
      iconCss={{
        color: 'feedback.success',
      }}
      isSuccess
    />
  );
};
